module.exports = __webpack_public_path__ + "img/13.19f306ff.jpg";